export const LEGACY_REDIRECTIONS = [
    // VIEWER LEGACY REDIRECTIONS (FOR QR CODES)
    // TO BE HOLDED FOREVER BECAUSE OF QR STICKERS
    { path: "/walls", redirect: "viewer" },
    { path: "/walls/:wall_uuid", redirect: to => ({ name: "assd_viewer", params: { assd_uuid: to.params.wall_uuid } }) },
    { path: "/units/:unit_uuid", redirect: to => ({ name: "ass_viewer", params: { ass_uuid: to.params.unit_uuid } }) },
]